import { render } from "./StudentDisciplinaryDialog.vue?vue&type=template&id=79cfc12d&scoped=true"
import script from "./StudentDisciplinaryDialog.vue?vue&type=script&lang=js"
export * from "./StudentDisciplinaryDialog.vue?vue&type=script&lang=js"

import "./StudentDisciplinaryDialog.vue?vue&type=style&index=0&id=79cfc12d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cfc12d"]])

export default __exports__